module.exports = __webpack_public_path__ + "img/756-6b377a.png";